var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.82353H15.2222M5.44444 1H10.7778M6.33333 13.2353V7.58824M9.88889 13.2353V7.58824M11.2222 17H5C4.01816 17 3.22222 16.1572 3.22222 15.1176L2.81636 4.80389C2.79531 4.26918 3.19904 3.82353 3.70447 3.82353H12.5177C13.0232 3.82353 13.4269 4.26918 13.4059 4.80389L13 15.1176C13 16.1572 12.2041 17 11.2222 17Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9f4f546cf1044a49547aa8404d099b1e.svg";
export { ForwardRef as ReactComponent };